import { render, staticRenderFns } from "./RelatedProductsTab.vue?vue&type=template&id=07471739&"
import script from "./RelatedProductsTab.vue?vue&type=script&lang=js&"
export * from "./RelatedProductsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports